import * as React from "react";
import Text from "../components/Entities/Text";
import Title from "../components/Entities/Title";
import RatingStars from "./Entities/RatingStars";
import Review from "./Review";

/**
 * Represents the props for the Review component.
 */
interface ReviewProps {
  title: string;
  comment: string;
  username: string;
  rating: number;
}

/**
 * Represents the props for the Reviews component.
 */
interface ReviewsProps {
  comments: ReviewProps[];
}
const Reviews: React.FC<ReviewsProps> = (props) => {
  const { comments } = props;

  /**
   *
   * @param review
   * @param index
   * @returns
   */
  const getReview = (review: any, index: number) => {
    const { title, comment, username, rating } = review;
    return (
      <div
        key={index}
        className="bg-primary rounded max-w-sm w-[100%] mx-auto p-4 my-4"
      >
        <Title
          value={{
            children: title,
            type: "h3",
            className: "text-white open-sans-normal",
          }}
        />
        <Text
          value={{
            injectedChildren: comment,
            className: "text-secondary text-sm open-sans-normal my-2",
          }}
        />
        <Text
          value={{
            injectedChildren: username,
            className: "text-white text-xs open-sans-light",
          }}
        />
        <RatingStars
          value={{
            onChange: null,
            selectedValue: rating,
            className: " text-center",
            fillColor: "#fff",
            emptyColor: "#fff",
            fontSize: "1.3rem",
          }}
        />
      </div>
    );
  };

  {
    return comments && comments.length > 0 ? (
      comments.map((review: any, index: number) => <Review review={review} key={index} />)
    ) : (
      <div className="py-10">
        <Text
          value={{
            injectedChildren: "No reviews from users yet!",
            className: "text-center text-secondary open-sans-normal",
          }}
        />
        <Text
          value={{
            injectedChildren: "Be the first one to review this world!",
            className: "text-center text-secondary open-sans-normal",
          }}
        />
      </div>
    );
  }
};

export default Reviews;
